var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ELSPageLoader } from '@els/els-ui-common-react';
import classNames from 'classnames';
import { Component } from 'react';
import { connect } from 'react-redux';
import { ELSIconV2 } from 'components/common';
import withAppLinkingBackToPreviousApp from 'components/common/with-app-linking-back-to-previous-app/withAppLinkingBackToPreviousApp';
import withRedirectToOutsideApp from 'components/common/with-redirect-to-outside-app/withRedirectToOutsideApp';
import { ANALYTIC_FEATURES, CS_APP_TITLE, FeatureFlagNames, REPORT_TITLE } from 'constants/app.constant';
import { EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { checkPathMatch, isBreadcrumbBackTitleShown } from 'helpers/app.helper';
import { onKeyDownHandler } from 'helpers/ui.helper';
import { appActions, appSelectors } from 'redux/ducks/app';
import { trackAAFeature } from 'services/adobe-analytics.service';
import { isCSAppByAppName, isEABAppByAppName } from 'services/app-linking.service';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { courseActions } from 'reports/cw/redux/ducks/courses';
import { HAD_PATHS, MASK_DATA_SESSION_KEY } from 'reports/had/constants/had.constant';
import { hadSelectors } from 'reports/had/redux/ducks/had';
import { PS_PATHS } from 'reports/ps/constants';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { shSelectors } from 'reports/sh/redux/ducks/sh';
import BentoBoxModal from '../bento-box-modal/BentoBoxModal';
import LinkButton from '../link-button/LinkButton';
import PageNavigator from '../page-navigator/PageNavigator';
import withResizeScreen from '../with-resize-screen/withResizeScreen';
import InternalBackButton from './InternalBackButton/InternalBackButton';
require('@els/els-styleguide-core/images/NonSolusLogo.svg');
require('assets/common/images/els-bento-box.svg');
require('assets/common/images/help-solid-circle.svg');
// Support icon click handler - placeholder for future implementation
var handleClickSupportIcon = function () {
    // TODO: Implement support icon click handling
};
var PageHeader = /** @class */ (function (_super) {
    __extends(PageHeader, _super);
    function PageHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCloseButton = function () { return (<button type="submit" className="u-els-debuttonize u-els-text-center u-els-padding-none u-els-display-inline-block u-els-margin-right-2x u-els-margin-right-1x@mobile c-page-header__close-btn" onClick={function () { return _this.handleBackPreviousAppIconClick(); }}>
      <ELSIconV2 id="Close" sprite="Close" className="u-els-color-secondary"/>
    </button>); };
        _this.handleCancel = function () {
            var openModal = _this.state.openModal;
            _this.setState({ openModal: !openModal });
        };
        _this.handleClickNavigationOtherReport = function () {
            trackAAFeature(ANALYTIC_FEATURES.PAGE_HEADER_ACCESS_ALL_DASHBOARD_LINK_CLICK);
            _this.setState(function (prevStates) { return ({ showBentoModal: !prevStates.showBentoModal }); });
        };
        _this.handleCourseSelectionModal = function () {
            _this.setState(function (prevStates) { return ({
                showCourseSelectionModal: !prevStates.showCourseSelectionModal,
                showBentoModal: false
            }); });
        };
        _this.handleOnClickOutsideModal = function () {
            _this.setState({ showBentoModal: false });
        };
        _this.handleBackPreviousAppIconClick = function () {
            if (checkPathMatch([PS_PATHS.homePage])) {
                trackAAFeature(ANALYTIC_FEATURES.PS_LANDING_PAGE_BACK_BUTTON_CLICK);
            }
            if (checkPathMatch([SH_PATHS.cpra])) {
                trackAAFeature(ANALYTIC_FEATURES.CRPA_BACK_TO_REFERRING_PAGE_CLICK);
            }
            // Use custom handler if provided, otherwise use the default HOC handler
            var backHandler = _this.props.customBackHandler || _this.props.handleBackPreviousAppIconClick;
            if (backHandler) {
                backHandler();
            }
        };
        _this.getIsFeatureNewHeaderEnable = function () {
            var _a = _this.props, featureFlags = _a.featureFlags, _b = _a.newHeaderShown, newHeaderShown = _b === void 0 ? false : _b;
            var isHADCWNewHeaderEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.HAD_CW_NEW_HEADER_ENABLE);
            if (!newHeaderShown) {
                if (sessionStorage.getItem(MASK_DATA_SESSION_KEY) === 'true') {
                    var shouldShowBentoIconForDemo = isFeatureEnabled(featureFlags, FeatureFlagNames.PERFROMANCE_DEMO_APP_ENABLED) || isFeatureEnabled(featureFlags, FeatureFlagNames.CW_DATA_MASKING_ENABLED);
                    return isHADCWNewHeaderEnabled && shouldShowBentoIconForDemo;
                }
                return isHADCWNewHeaderEnabled;
            }
            return newHeaderShown;
        };
        _this.state = {
            openModal: false,
            showBentoModal: false,
            showCourseSelectionModal: false,
            titleHeader: isCSAppByAppName(props.breadcrumbBackTitle) ? CS_APP_TITLE : PageHeader.getInitialTitleHeader(props)
        };
        return _this;
    }
    PageHeader.prototype.componentDidUpdate = function () {
        var newTitleHeader = PageHeader.getInitialTitleHeader(this.props);
        if (newTitleHeader !== this.state.titleHeader) {
            this.setState({ titleHeader: newTitleHeader });
        }
    };
    PageHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, isBackToPreviousAppIconShown = _a.isBackToPreviousAppIconShown, breadcrumbBackTitle = _a.breadcrumbBackTitle, customClass = _a.customClass, children = _a.children, showNavigation = _a.showNavigation, hideBackToPreviousAppIcon = _a.hideBackToPreviousAppIcon, featureFlags = _a.featureFlags, selectedCourse = _a.selectedCourse, hadPrograms = _a.hadPrograms, isEAQTopicMappedHesiExamLoading = _a.isEAQTopicMappedHesiExamLoading, isCWLinkHADAndEHRChecking = _a.isCWLinkHADAndEHRChecking, isHesiReadinessApp = _a.isHesiReadinessApp, subTitle = _a.subTitle, windowMode = _a.windowMode, courses = _a.courses, componentBelowHeader = _a.componentBelowHeader, currentAppLinkPage = _a.currentAppLinkPage, customAppLinkRedirectUrl = _a.customAppLinkRedirectUrl, studentNameDisplay = _a.studentNameDisplay, isCWSubNavInEHRPageShow = _a.isCWSubNavInEHRPageShow, appLinkOutPostBody = _a.appLinkOutPostBody, instructorId = _a.instructorId, bentoBoxShown = _a.bentoBoxShown, customHeaderItem = _a.customHeaderItem, isProgramSolutionsEnabled = _a.isProgramSolutionsEnabled, isEhrReportingEnabled = _a.isEhrReportingEnabled, isEmergePackageEnabled = _a.isEmergePackageEnabled, isLaunchedInNewTab = _a.isLaunchedInNewTab, backToLabelOverride = _a.backToLabelOverride, _b = _a.supportIconShown, supportIconShown = _b === void 0 ? false : _b, _c = _a.autoHideBento, autoHideBento = _c === void 0 ? false : _c, _d = _a.showBentoIcon, showBentoIcon = _d === void 0 ? true : _d, _e = _a.showChildren, showChildren = _e === void 0 ? false : _e, _f = _a.isInternalBackButtonShown, isInternalBackButtonShown = _f === void 0 ? false : _f, _g = _a.hideLogo, hideLogo = _g === void 0 ? false : _g;
        var _h = this.state, openModal = _h.openModal, showBentoModal = _h.showBentoModal, showCourseSelectionModal = _h.showCourseSelectionModal, titleHeader = _h.titleHeader;
        var isShowEAQTopicReport = !isEABAppByAppName(breadcrumbBackTitle);
        var isHADPath = checkPathMatch(Object.values(HAD_PATHS));
        var pageNavigatorProps = {
            openModal: openModal,
            handleCancel: this.handleCancel,
            featureFlags: featureFlags,
            selectedCourse: selectedCourse,
            hadPrograms: hadPrograms,
            isCWLinkHADAndEHRChecking: isCWLinkHADAndEHRChecking,
            isHesiReadinessApp: isHesiReadinessApp,
            currentAppLinkPage: currentAppLinkPage,
            customAppLinkRedirectUrl: customAppLinkRedirectUrl,
            studentNameDisplay: studentNameDisplay,
            isShowEAQTopicReport: isShowEAQTopicReport,
            isHADPath: isHADPath,
            isCWSubNavInEHRPageShow: isCWSubNavInEHRPageShow,
            appLinkOutPostBody: appLinkOutPostBody,
            isEhrReportingEnabled: isEhrReportingEnabled,
            isCSApp: isCSAppByAppName(breadcrumbBackTitle)
        };
        var bentoBoxModal = {
            hadPrograms: hadPrograms,
            selectedCourse: selectedCourse,
            isEAQTopicMappedHesiExamLoading: isEAQTopicMappedHesiExamLoading,
            isCWLinkHADAndEHRChecking: isCWLinkHADAndEHRChecking,
            isHesiReadinessApp: isHesiReadinessApp,
            showCourseSelectionModal: showCourseSelectionModal,
            visible: showBentoModal,
            handleCourseSelectionModal: this.handleCourseSelectionModal,
            onClickOutSide: this.handleOnClickOutsideModal,
            courses: courses,
            instructorId: instructorId,
            autoHideBento: autoHideBento,
            isProgramSolutionsEnabled: isProgramSolutionsEnabled
        };
        var isFeatureNewHeaderEnable = this.getIsFeatureNewHeaderEnable();
        if (this.props.appLoading) {
            return <ELSPageLoader />;
        }
        // A new-tab launch has no meaningful back target (the source app is still open in the other tab),
        // so suppress every back button regardless of app-link/Emerge/internal state.
        var backAppIconShown = !isLaunchedInNewTab &&
            !hideBackToPreviousAppIcon &&
            (isEmergePackageEnabled || (!isInternalBackButtonShown && isBackToPreviousAppIconShown && isBreadcrumbBackTitleShown(breadcrumbBackTitle)));
        var bentoIconShown = autoHideBento ? bentoBoxShown : showBentoIcon;
        var backToLabel = backToLabelOverride || breadcrumbBackTitle;
        // Only render the dashboard back link if a real label exists. Emerge launches without a
        // resolved previous-app label should fall back to the native browser/internal back behavior.
        var showBackToAppButton = backAppIconShown && !!backToLabel;
        // Fall back to the browser-history back button only when the previous dashboard cannot be
        // resolved to a label, or when a page explicitly opts into the internal back button. Never show
        // it alongside the "Back to <dashboard>" button.
        var showInternalBackButton = !isLaunchedInNewTab && !showBackToAppButton && (isInternalBackButtonShown || backAppIconShown);
        return (<>
        {isFeatureNewHeaderEnable && !windowMode.mobile && titleHeader ? (<>
            <nav className={classNames('c-page-header c-page-header--border-none u-els-padding-none o-els-flex-layout--wrap', customClass)}>
              {bentoIconShown && <BentoBoxModal {...bentoBoxModal}/>}
              <div className="u-max-width-1400 u-els-padding-left-1x1o2 u-els-padding-right-1x1o2 c-page-header__content">
                <div className="c-page-header__content-detail">
                  {!hideLogo && (<svg className="c-page-header__content-detail-logo" aria-hidden="true" focusable="false">
                      <use xlinkHref="#NonSolusLogo"/>
                    </svg>)}
                  <span className="sr-only">Elsevier</span>
                  <div>
                    <h3>{titleHeader}</h3>
                    {subTitle && <h5>{subTitle}</h5>}
                    {showBackToAppButton && (<LinkButton onClick={this.handleBackPreviousAppIconClick} type="container">
                        <div className="u-els-color-secondary u-els-margin-top-1o4 c-page-header__content-detail-navigation">
                          <ELSIconV2 id="ChevronLeft" sprite="ChevronLeft"/>
                          <span className="u-els-font-size-base u-els-margin-left-1o2 u-els-margin-top-1o4 ">{"Back to ".concat(backToLabel)}</span>
                        </div>
                      </LinkButton>)}
                    {showInternalBackButton && <InternalBackButton />}
                  </div>

                  {!!customHeaderItem && <div className="c-page-header__content-detail-navigation">{customHeaderItem}</div>}

                  {bentoIconShown && (<div role="button" tabIndex={0} onClick={this.handleClickNavigationOtherReport} onKeyDown={function (evt) { return onKeyDownHandler(evt, _this.handleClickNavigationOtherReport); }} className={classNames('c-page-header__content-detail-navigation u-els-color-secondary', {
                        'u-els-margin-left-2x': !!customHeaderItem,
                        auto: !customHeaderItem
                    })}>
                      <svg className="o-els-icon-svg o-els-icon-svg--2x">
                        <use xlinkHref="#els-bento-box"/>
                      </svg>
                      <div className="u-els-margin-left-3o4">
                        Access All
                        <br />
                        Dashboards
                      </div>
                    </div>)}
                  {supportIconShown && (<div role="button" tabIndex={0} onClick={handleClickSupportIcon} onKeyDown={function (evt) { return onKeyDownHandler(evt, handleClickSupportIcon); }} className="u-els-color-secondary u-els-margin-left-1x c-page-header__content-detail-navigation">
                      <svg className="o-els-icon-svg o-els-icon-svg--2x">
                        <use xlinkHref="#help-solid-circle"/>
                      </svg>
                      <div className="u-els-margin-left-1o2">Support</div>
                    </div>)}
                </div>
              </div>
              <div className="c-page-header__content-line"/>
              {showChildren && (<div className="c-page-header__content-line">
                  <div className="u-max-width-1400 c-page-header__content-children">{children}</div>
                </div>)}
            </nav>
            {!!componentBelowHeader && <div className="c-page-header__content-line">{componentBelowHeader}</div>}
          </>) : (<nav className={classNames('u-els-padding c-page-header', customClass)}>
            {backAppIconShown && this.renderCloseButton()}
            <div className="u-els-padding-right c-page-header__content">{children}</div>
            {showNavigation && (<span role="button" tabIndex={0} onClick={this.handleCancel} onKeyDown={function (evt) { return onKeyDownHandler(evt, _this.handleCancel); }}>
                <ELSIconV2 id="Menu" sprite="Menu" className={classNames({ 'u-els-color-secondary': isHADPath }, 'c-page-navigator__icon')} size="m"/>
              </span>)}
          </nav>)}
        {showNavigation && <PageNavigator {...pageNavigatorProps}/>}
      </>);
    };
    PageHeader.getInitialTitleHeader = function (props) {
        var _a;
        if (props.newHeaderShown) {
            return props.title;
        }
        var isSherpathApp = props.breadcrumbBackTitle === EXTERNAL_APP_INFO.APP_LINKING.SHERPATH.backTitle;
        if (isSherpathApp && ((_a = props.title) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(REPORT_TITLE.SHERPATH_PERFORMANCE_GRADES.backTo.toLocaleLowerCase()))) {
            return REPORT_TITLE.SHERPATH_PERFORMANCE_GRADES.defaultTitle;
        }
        return props.title;
    };
    return PageHeader;
}(Component));
var mapDispatchToProps = function (dispatch) { return ({
    setSelectedCourse: function (courseId) { return dispatch(appActions.setSelectedCourse(courseId)); },
    setCourseSectionInfo: function (courseSectionInfo) { return dispatch(courseActions.setCourseSectionInfo(courseSectionInfo)); }
}); };
var mapStateToProps = function (state) {
    return {
        featureFlags: appSelectors.getFeatureFlags(state),
        selectedCourse: appSelectors.getSelectedCourse(state),
        appLoading: appSelectors.getAppLoading(state),
        breadcrumbBackTitle: appSelectors.getBreadcrumbBackTitle(state),
        isBackToPreviousAppIconShown: appSelectors.getIsBackToPreviousAppIconShown(state),
        isCWLinkHADAndEHRChecking: appSelectors.getIsCWLinkHADAndEHRChecking(state),
        isEAQTopicMappedHesiExamLoading: appSelectors.getIsEAQTopicMappedHesiExamLoading(state),
        courses: appSelectors.getCourses(state),
        isCWSubNavInEHRPageShow: appSelectors.getIsCWSubNavInEHRPageShow(state),
        appLinkOutPostBody: appSelectors.getAppLinkOutPostBody(state),
        hadPrograms: hadSelectors.getPrograms(state),
        instructorId: shSelectors.getInstructorId(state),
        bentoBoxShown: appSelectors.getBentoBoxShown(state),
        isProgramSolutionsEnabled: appSelectors.getIsProgramSolutionsEnabled(state),
        isEhrReportingEnabled: appSelectors.getIsEhrReportingEnabled(state),
        isEmergePackageEnabled: appSelectors.getIsEmergePackageEnabled(state),
        isLaunchedInNewTab: appSelectors.getIsLaunchedInNewTab(state)
    };
};
export { PageHeader as PageHeaderBase };
export default connect(mapStateToProps, mapDispatchToProps)(withResizeScreen(withRedirectToOutsideApp(withAppLinkingBackToPreviousApp(PageHeader))));
